<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>
        <a-form-model ref="form" :model="form" :rules="rules">
            <h2>$$$$$: 替换为链接</h2>
            <h2>^^^^^: 替换为剧名</h2>
            <h2>&&&&&: 替换为邀请码</h2>
            <a-form-model-item label="中文内容" prop="content">
                <a-textarea :row="3" v-model="form.content" />
            </a-form-model-item>
            <a-form-model-item label="英文内容" prop="contentEn">
                <a-textarea :row="3" v-model="form.contentEn" />
            </a-form-model-item>
            <a-form-model-item label="日语内容" prop="contentJa">
                <a-textarea :row="3" v-model="form.contentJa" />
            </a-form-model-item>

            <a-form-model-item label="印尼内容" prop="contentId">
                <a-textarea :row="3" v-model="form.contentId" />
            </a-form-model-item>

            <a-form-model-item label="葡语内容" prop="contentPt">
                <a-textarea :row="3" v-model="form.contentPt" />
            </a-form-model-item>

            <a-form-model-item label="西语内容" prop="contentEs">
                <a-textarea :row="3" v-model="form.contentEs" />
            </a-form-model-item>

            <a-form-model-item label="封面图" prop="coverUrl">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrl" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload"
                    :customRequest="handleChange">
                    <plus-outlined />
                    <img v-if="form.coverUrl" :src="form.coverUrl" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>
            <a-form-model-item label="英文封面图" prop="coverUrlEn">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlEn" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload1"
                    :customRequest="handleChange1">
                    <plus-outlined />
                    <img v-if="form.coverUrlEn" :src="form.coverUrlEn" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading1 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>
            <a-form-model-item label="日语封面图" prop="coverUrlJa">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlJa" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload2"
                    :customRequest="handleChange2">
                    <plus-outlined />
                    <img v-if="form.coverUrlJa" :src="form.coverUrlJa" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading2 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="印尼封面图" prop="coverUrlId">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlId" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload3"
                    :customRequest="handleChange3">
                    <plus-outlined />
                    <img v-if="form.coverUrlId" :src="form.coverUrlId" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading3 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="葡语封面图" prop="coverUrlPt">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlPt" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload4"
                    :customRequest="handleChange4">
                    <plus-outlined />
                    <img v-if="form.coverUrlPt" :src="form.coverUrlPt" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading4 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="西语封面图" prop="coverUrlEs">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.coverUrlEs" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload5"
                    :customRequest="handleChange5">
                    <plus-outlined />
                    <img v-if="form.coverUrlEs" :src="form.coverUrlEs" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading5 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="类型" prop="type">
                <a-select v-model="form.type" placeholder="请选择">
                    <a-select-option :value="1">分享剧集</a-select-option>
                    <a-select-option :value="2">邀请好友</a-select-option>
                </a-select>
            </a-form-model-item>

            <!-- <a-form-model-item label="渠道" prop="channel">
                <a-select v-model="form.channel" placeholder="请选择">
                    <a-select-option :value="1">facebook</a-select-option>
                    <a-select-option :value="2">twitter</a-select-option>
                    <a-select-option :value="3">whatsapp</a-select-option>
                    <a-select-option :value="4">other</a-select-option>
                </a-select>
            </a-form-model-item> -->

            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>
  
<script>
import { getShare, addShare, updateShare } from '@/api/video/shareMaterial'
import UploadFileToVOD from "@/api/vod.js"
import Editor from '@/components/Editor'

export default {
    name: 'CreateForm',
    props: {
    },
    components: {
        Editor
    },
    data() {
        return {
            submitLoading: false,
            uploadLoading: false,
            uploadLoading1: false,
            uploadLoading2: false,
            uploadLoading3: false,
            uploadLoading4: false,
            uploadLoading5: false,
            formTitle: '',
            // 表单参数
            form: {
                id: null,

                content: '',

                contentEn: '',

                contentJa: '',

                contentId: '',

                contentPt: '',

                contentEs: '',

                coverUrl: '',

                coverUrlEn: '',

                coverUrlJa: '',

                coverUrlId: '',

                coverUrlPt: '',

                coverUrlEs: '',

                type: null,
                
                channel: null

            },
            // 1增加,2修改
            formType: 1,
            open: false,
            rules: {
                type: [
                    { required: true, message: '类型不能为空' }
                ],
                // channel: [
                //     { required: true, message: '渠道不能为空' }
                // ],
                contentEn: [
                    { required: true, message: '英文内容不能为空' }
                ]
            }
        }
    },
    filters: {
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        handleChange(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrl = fileName[0];//文件名
                    that.uploadLoading = false;
                },

            });
            that.uploadLoading = false;
        },
        beforeUpload: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading = false
                return false;
            }
            this.form.coverUrl = ""
        },
        handleChange1(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrlEn = fileName[0];//文件名
                    that.uploadLoading1 = false;
                },

            });
            that.uploadLoading1 = false;
        },
        beforeUpload1: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading1 = false
                return false;
            }
            this.form.coverUrlEn = ""
        },
        handleChange2(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrlJa = fileName[0];//文件名
                    that.uploadLoading2 = false;
                },

            });
            that.uploadLoading2 = false;
        },
        beforeUpload2: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading2 = false
                return false;
            }
            this.form.coverUrlJa = ""
        },

        handleChange3(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrlId = fileName[0];//文件名
                    that.uploadLoading3 = false;
                },

            });
            that.uploadLoading3 = false;
        },
        beforeUpload3: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading3 = false
                return false;
            }
            this.form.coverUrlId = ""
        },

        handleChange4(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrlPt = fileName[0];//文件名
                    that.uploadLoading4 = false;
                },

            });
            that.uploadLoading4 = false;
        },
        beforeUpload4: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading4 = false
                return false;
            }
            this.form.coverUrlPt = ""
        },

        handleChange5(info) {
            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.coverUrlEs = fileName[0];//文件名
                    that.uploadLoading5 = false;
                },

            });
            that.uploadLoading5 = false;
        },
        beforeUpload5: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading5 = false
                return false;
            }
            this.form.coverUrlEs = ""
        },
        onClose() {
            this.reset();
            this.open = false
        },
        // 取消按钮
        cancel() {
            this.reset()
            this.open = false
        },
        // 表单重置
        reset() {
            this.formType = 1
            this.form = {
                id: null,
                content: '',
                contentEn: '',
                contentJa: '',
                contentId: '',
                contentPt: '',
                contentEs: '',
                coverUrl: '',
                coverUrlEn: '',
                coverUrlJa: '',
                coverUrlId: '',
                coverUrlPt: '',
                coverUrlEs: '',
                type: null,
                channel: null
            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
            })
        },
        /** 新增按钮操作 */
        handleAdd(row) {
            this.reset()
            this.formType = 1
            this.open = true
            this.formTitle = '添加'
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            this.formType = 2
            const id = row ? row.id : ids
            getShare({ 'id': id }).then(response => {
                this.form = response.data
                debugger
                console.log(this.form)
                this.open = true
                this.formTitle = '修改'
            })
        },
        /** 提交按钮 */
        submitForm: function () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.form.id !== undefined && this.form.id !== null) {
                        console.log('表单内容：', this.form)
                        updateShare(this.form).then(response => {
                            this.$message.success(
                                '修改成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    } else {
                        addShare(this.form).then(response => {
                            this.$message.success(
                                '新增成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>
  